export default __webpack_public_path__ + "static/live-offer-health-check-cd30c4c6e0d9b0911f9a8fd78bf98792.jpg";